module.exports = __webpack_public_path__ + "img/viewiconn.cf266b1f.svg";